import { allauthClient } from '../shared/httpClients'

export function fetchSession() {
  return allauthClient.get('/auth/session').then((response) => response.data)
}

export function loginWithPassword(email, password) {
  return allauthClient
    .post('/auth/login', { email, password })
    .then((response) => response.data)
}

export function logoutSession() {
  return allauthClient.post('/auth/logout').then(() => true)
}
